const cacheMap = {};

export function throughPromiseCache(keyObject, callback) {
  const cacheKey = JSON.stringify(keyObject);

  const cache = cacheMap[cacheKey];

  if (cache) {
    return cache;
  }

  return (cacheMap[cacheKey] = callback().then(
    function(res) {
      delete cacheMap[cacheKey];
      return res;
    },
    function(error) {
      delete cacheMap[cacheKey];
      throw error;
    }
  ));
}
